import clsx from 'clsx';
import {GroupFilterContext} from 'context/groupFilterContext';
import {useGetTranslatedCategory} from 'hooks/useGetTranslatedCategory';
import React, {useContext} from 'react';
import {useFormContext} from 'react-hook-form';

import {palette} from 'styles/mui/scss';

import {Box, Grid, Typography} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

import styles from './styles/CarFilterCategorySwitch.module.scss';

export const CarFilterCategorySwitch = ({}) => {
  const getTranslatedCategory = useGetTranslatedCategory();
  return (
    <Grid container columnSpacing={'2%'} direction={'row'}>
      <Grid xxs={6} className={styles.categoryButtonWrapper} data-testid="pkw">
        <CategoryCheckboxButton
          testValue="pkw"
          category={getTranslatedCategory('pkw')}
          icon="car"
        />
      </Grid>
      <Grid
        xxs={6}
        className={styles.categoryButtonWrapper}
        data-testid="lkw"
        data-category-key="lkw"
      >
        <CategoryCheckboxButton
          testValue="lkw"
          category={getTranslatedCategory('lkw')}
          icon="truck"
        />
      </Grid>
    </Grid>
  );
};

function CategoryCheckboxButton({category, icon, testValue}) {
  const {
    currentCategory,
    availableCategories,
    categoryPriceMapping,
    withPrice,
  } = useContext(GroupFilterContext);
  const {setValue} = useFormContext();
  //set price when switching category to avoid racecondition rendering bugs
  return (
    <Box
      data-testid={`categorySwitchButton-${testValue}`}
      onClick={e => {
        if (!availableCategories.includes(category)) {
          e.preventDefault();
          return;
        }
        if (withPrice && category in categoryPriceMapping) {
          setValue('price', [
            Math.min(...categoryPriceMapping[category]),
            Math.max(...categoryPriceMapping[category]),
          ]);
        }
        setValue('category', category);
      }}
      className={clsx(styles.categoryButton, {
        [styles.categoryButtonDisabled]: !availableCategories.includes(category),
      })}
      sx={{
        backgroundColor: category === currentCategory ? 'rgba(254, 237, 1, 0.15)' : '#f7f7f7',
        '& *': {
          color: availableCategories.includes(category) ? palette.colorGrey80 : palette.colorGrey20,
        },
      }}
    >
      <CustomIcon name={icon} className={styles.icon} />
      <Typography variant="buttonCards" className={styles.label}>
        {category}
      </Typography>
    </Box>
  );
}
